import { render, staticRenderFns } from "./shipinbs.vue?vue&type=template&id=eb579e8a&scoped=true"
import script from "./shipinbs.vue?vue&type=script&lang=js"
export * from "./shipinbs.vue?vue&type=script&lang=js"
import style0 from "./shipinbs.vue?vue&type=style&index=0&id=eb579e8a&prod&lang=less"
import style1 from "./shipinbs.vue?vue&type=style&index=1&id=eb579e8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb579e8a",
  null
  
)

export default component.exports